<script>
  import Spinner from "../components/ihm/ToolsSpinner.svelte";
  import { urlServeur } from "./conf.js";

  let brutRows = [];

  const fetchData = async () => {
    return fetch(urlServeur + "/api/immeubles/opecars/")
    .then (response => response.json())
    .then (result => brutRows = result.payload)
    .catch(error => {
        console.log('Recup info cars in hs ', error)
    })
  };

  const calculByMois = (montant, nbremois) => {
    let result = 0;
    if (nbremois != 0) {
      result = montant / nbremois;
    } else {
      result = montant;
    }

    return new Intl.NumberFormat("fr-FR").format(Math.round(result));
  };

  const promise = fetchData();
</script>
<div class="container">
<h4>Récap frais voitures</h4>
{#await promise}
  <Spinner />
{:then data}
  {#each Object.entries(brutRows) as [name, detail]}
    <h6 class="bg-info">{name}</h6>
    <table width="100%" class="table table-success table-striped">
      <thead>
        <tr class="titre bg-info">
          <td>année</td>
          <td>Total</td>
          <td>moy.mois</td>
        </tr>
      </thead>
      <tbody>
        {#each detail as element}
          <tr class={element.annee == "Total" ? "titre bg-success" : ""}>
            <td>{element.annee}</td>
            <td>{new Intl.NumberFormat("fr-FR").format(element.montant)}</td>
            <td class="text-end"
              >{element.annee != "Total"
                ? new Intl.NumberFormat("fr-FR").format(
                    Math.round(element.montant / 12)
                  )
                : calculByMois(element.montant, parseFloat(element.nbmois))}
              {element.annee != "Total" ? "" : " - (" + element.nbmois + ")"}
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
    <br />
  {/each}
{/await}
</div>
<style>
  .titre {
    font-weight: bold;
  }
  h6 {
    margin-bottom: -4px;
    padding: 5px 0 5px 10px;
  }
</style>
